export { default as ListadoArticulosVendidosPorFamilia } from "./Listado";
